import { useMediaQuery, useTheme } from '@mui/material';
import { BooleanParam, useQueryParam } from 'use-query-params';

import { getProcedurePageCardsPerRow, useProcedurePageLayout } from './useProcedurePageLayout';

export const useProcedurePageColumns = (): {
  layout: 'large' | 'medium';
  xs: number;
  sm: number;
  md: number;
  lg: number;
} => {
  const [advancedSearchDrawerOpen] = useQueryParam('advancedSearchDrawerOpen', BooleanParam);
  const layout: 'large' | 'medium' = advancedSearchDrawerOpen ? 'medium' : 'large';
  const { cardsPerRow } = useProcedurePageLayout();
  const responsiveCardsPerRow = getProcedurePageCardsPerRow({
    cardsPerRow,
    layout,
  });

  return {
    layout,
    xs: responsiveCardsPerRow.xs,
    sm: responsiveCardsPerRow.sm,
    md: responsiveCardsPerRow.md,
    lg: responsiveCardsPerRow.lg,
  };
};

export const useCurrentProcedurePageCardsPerRow = () => {
  const theme = useTheme();
  const { xs, sm, md, lg } = useProcedurePageColumns();
  const isLargeViewport = useMediaQuery(theme.breakpoints.up('lg'));
  const isMediumViewport = useMediaQuery(theme.breakpoints.up('md'));
  const isSmallViewport = useMediaQuery(theme.breakpoints.up('sm'));

  if (isLargeViewport) {
    return lg;
  }

  if (isMediumViewport) {
    return md;
  }

  if (isSmallViewport) {
    return sm;
  }

  return xs;
};
